var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDiet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "24px",
    height: "24px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 1C15 1 13 3 13 5.5s2 4.5 4.5 4.5 4.5-2 4.5-4.5S20 1 17.5 1zm-11 8C4 9 2 11 2 13.5S4 18 6.5 18s4.5-2 4.5-4.5S9 9 6.5 9zm11 7c-2.5 0-4.5 2-4.5 4.5s2 4.5 4.5 4.5 4.5-2 4.5-4.5-2-4.5-4.5-4.5zM13.41 4.59l-1.41-1.41L10.59 4.5 12 6l1.41-1.41zM4.5 12.09L3.09 13.5 4.5 14.91 5.91 13.5 4.5 12.09zm13 7L16.09 20.5l1.41 1.41L19 20.5l-1.5-1.41z",
    transform: "scale(0.8) translate(3, 3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDiet);
export default __webpack_public_path__ + "static/media/icon-diet.eef62392c856d80427858e026f96f8a4.svg";
export { ForwardRef as ReactComponent };